import React from 'react';
import DiagnosticReports from '../containers/DiagnosticReports.jsx';
import DemoAccountContextProvider from '../contexts/DemoAccountContextProvider';

export default ({ isDemo = false, ...props }) => (
  <DemoAccountContextProvider isDemo={isDemo}>
    <DiagnosticReports {...props} />
  </DemoAccountContextProvider>
);
